import React from 'react'
import classNames from 'classnames';
import Input from '../../../components/forms/Input'
import Checkbox from '../../../components/forms/Checkbox'
import { createPortal } from 'react-dom';

const EmailStepDesktop = ({
  data,
  email,
  onChangeEmail,
  showMarketingCheckbox,
  form,
  handleCheckboxChange,
  onSkipEmail,
  onContinueClick,
  emailValid,
}) => {
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <div>
      <p className="mb-10 heading-large text-primary">{data.title}</p>
        <Input
          variant="wizard"
          type="email"
          placeholder={data.textInsideEmailBox}
          value={email}
          onChange={onChangeEmail}
        />
        <div className={classNames("mt-4 wizard-email__consent", { 'wizard-email__consent-hide': !emailValid })}>
          <div className="text-sm text-tertiary font-medium">{data.textBelowEmail}</div>
          {showMarketingCheckbox && (
            <div className="consent-message">
              <Checkbox
                label={data.marketingCheckboxText}
                checked={form.marketingCheckbox}
                onChange={handleCheckboxChange}
                wrapClassNames="wizard-checkbox mt-4"
              />
            </div>
          )}
        </div>
        <div className="mt-10">
          <span className="wizard-email__skip-link cursor-pointer" onClick={onSkipEmail}>{data.skipTextRow}</span>
        </div>

      {footerPortal && createPortal(
        <button className={classNames("wizard-btn wizard-btn--next", { 'wizard-btn--next-skip': !emailValid })} onClick={onContinueClick}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default EmailStepDesktop
